import React from "react";
import { Trans } from "react-i18next";
import Popup, {
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../../../../components/Common/Popup";

export default ({ open, handleYes, handleNo, ...other }) => {
  // FIXME: Text "Would you like to replace all pictures in this module?"
  // should be updated to "Would you like to update all picture fields in this module?"
  return (
    <Popup
      open={open}
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      {...other}
    >
      <PopupHeading id="confirmation-dialog-title">
        <Trans>Replace all pictures?</Trans>
      </PopupHeading>
      <PopupContent dividers>
        <Trans>Would you like to replace all pictures in this module?</Trans>
      </PopupContent>
      <PopupActions>
        <PopupButton secondary onClick={handleNo} color="primary">
          <Trans>No, replace this picture only</Trans>
        </PopupButton>

        <PopupButton autoFocus onClick={handleYes} color="primary">
          <Trans>Yes, replace all pictures</Trans>
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};
